import GeneralLedgerMappingOverride from '@/models/Products/ProductGeneralLedgerMapping/GeneralLedgerMappingOverride';

export default class UpdateGeneralLedgerMappingOverrideRequest extends GeneralLedgerMappingOverride {

    public constructor(settings: GeneralLedgerMappingOverride, updatedAt: Date) {
        super();
        this.updatedAt = updatedAt;
        this.generalLedgerAccountMappingId = settings.generalLedgerAccountMappingId;
        this.transactionType = settings.transactionType;
        this.state = settings.state;
        this.debitGLAccountId = settings.debitGLAccountId;
        this.creditGLAccountId = settings.creditGLAccountId;
        this.subtransactionTypeId = settings.subtransactionTypeId;
    }
}